import React, { useState, useEffect, useCallback } from 'react';
import Pagination from './Pagination';
import './MyCoupons.css';

const API_BASE = '/api';

function parseMatchName(name) {
  if (!name) return { home: { team: '', player: '' }, away: { team: '', player: '' } };
  const parts = name.split(' - ');
  if (parts.length < 2) return { home: { team: name, player: '' }, away: { team: '', player: '' } };
  const parseSide = (s) => {
    const trimmed = s.trim();
    const m = trimmed.match(/^(.+?)\s*\(([^)]+)\)$/);
    if (m) {
      const tag = m[2].trim();
      if (tag === 'K') return { team: trimmed, player: '' };
      return { team: trimmed, player: tag };
    }
    return { team: trimmed, player: '' };
  };
  return { home: parseSide(parts[0]), away: parseSide(parts.slice(1).join(' - ')) };
}

function MyCoupons({ onNavigate }) {
  const [coupons, setCoupons] = useState([]);
  const [bekleyen, setBekleyen] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, limit: 20, total: 0, totalPages: 0 });
  const [loading, setLoading] = useState(false);
  const [syncing, setSyncing] = useState(false);
  const [syncResult, setSyncResult] = useState(null);
  const [barcodeChecking, setBarcodeChecking] = useState(false);
  const [barcodeCheckResult, setBarcodeCheckResult] = useState(null);
  const [stats, setStats] = useState(null);
  const [users, setUsers] = useState([]);
  const [displayNameMap, setDisplayNameMap] = useState({});
  const [currentUser, setCurrentUser] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [loadingBekleyen, setLoadingBekleyen] = useState(false);

  const [showBekleyen, setShowBekleyen] = useState(true);
  const [showKazanan, setShowKazanan] = useState(true);
  const [showKaybeden, setShowKaybeden] = useState(true);
  const [showRoyal, setShowRoyal] = useState(false);

  const _now = new Date();
  const _y = _now.getFullYear(), _m = String(_now.getMonth() + 1).padStart(2, '0'), _d = String(_now.getDate()).padStart(2, '0');
  const [filterStartDate, setFilterStartDate] = useState(`${_y}-${_m}-01`);
  const [filterEndDate, setFilterEndDate] = useState(`${_y}-${_m}-${_d}`);
  const [filterBarcode, setFilterBarcode] = useState('');
  const [filterMinOdd, setFilterMinOdd] = useState('');
  const [filterMaxOdd, setFilterMaxOdd] = useState('');
  const [filterMinAmount, setFilterMinAmount] = useState('');
  const [filterMaxAmount, setFilterMaxAmount] = useState('');
  const [filterPlayer, setFilterPlayer] = useState('');
  const [filterTeam, setFilterTeam] = useState('');
  const [filterMinGain, setFilterMinGain] = useState('');
  const [filterMaxGain, setFilterMaxGain] = useState('');
  const [filterVersion, setFilterVersion] = useState(0);

  const token = localStorage.getItem('token');

  const fetchUsers = useCallback(async () => {
    try {
      const res = await fetch(`${API_BASE}/coupons/users`, { headers: { Authorization: `Bearer ${token}` } });
      const data = await res.json();
      if (data.success) {
        setUsers(data.users || []);
        setDisplayNameMap(data.displayNameMap || {});
        setCurrentUser(data.currentUser);
        setIsLoggedIn(data.isLoggedIn);
        // selectedUsers stays empty = Tümü (all users)
      }
    } catch (err) { console.error('Users fetch error:', err); }
  }, [token]);

  const fetchBekleyen = useCallback(async () => {
    if (!isLoggedIn) { setBekleyen([]); return; }
    setLoadingBekleyen(true);
    try {
      const res = await fetch(`${API_BASE}/coupons/bekleyen?all=true`, { headers: { Authorization: `Bearer ${token}` } });
      const data = await res.json();
      if (data.success) setBekleyen(data.data || []);
      else setBekleyen([]);
    } catch (err) { console.error('Bekleyen fetch error:', err); }
    setLoadingBekleyen(false);
  }, [token, isLoggedIn]);

  const fetchCoupons = useCallback(async (page = 1) => {
    if (!showKazanan && !showKaybeden && !showRoyal) {
      setCoupons([]); setPagination({ page: 1, limit: 20, total: 0, totalPages: 0 }); return;
    }
    setLoading(true);
    try {
      const params = new URLSearchParams();
      params.set('page', page); params.set('limit', 20);
      if (selectedUsers.length > 0) params.set('nesineUser', selectedUsers.join(','));
      if (showRoyal) {
        params.set('isRoyal', 'true');
      } else if (showKazanan && !showKaybeden) params.set('resultType', '2');
      else if (!showKazanan && showKaybeden) params.set('resultType', '3');
      if (filterStartDate) params.set('startDate', filterStartDate);
      if (filterEndDate) params.set('endDate', filterEndDate);
      if (filterBarcode.trim()) params.set('barcode', filterBarcode.trim());
      const res = await fetch(`${API_BASE}/coupons/list?${params.toString()}`, { headers: { Authorization: `Bearer ${token}` } });
      const data = await res.json();
      if (data.success) { setCoupons(data.data); setPagination(data.pagination); }
    } catch (err) { console.error('Coupons fetch error:', err); }
    setLoading(false);
  }, [token, selectedUsers, showKazanan, showKaybeden, showRoyal, filterStartDate, filterEndDate, filterBarcode]);

  const fetchStats = useCallback(async (filters) => {
    try {
      const params = new URLSearchParams();
      if (selectedUsers.length > 0) params.set('nesineUser', selectedUsers.join(','));
      if (filters) {
        if (filters.startDate) params.set('startDate', filters.startDate);
        if (filters.endDate) params.set('endDate', filters.endDate);
        if (filters.barcode) params.set('barcode', filters.barcode);
        if (filters.minOdd) params.set('minOdd', filters.minOdd);
        if (filters.maxOdd) params.set('maxOdd', filters.maxOdd);
        if (filters.minAmount) params.set('minAmount', filters.minAmount);
        if (filters.maxAmount) params.set('maxAmount', filters.maxAmount);
        if (filters.minGain) params.set('minGain', filters.minGain);
        if (filters.maxGain) params.set('maxGain', filters.maxGain);
      }
      const res = await fetch(`${API_BASE}/coupons/stats?${params.toString()}`, { headers: { Authorization: `Bearer ${token}` } });
      const data = await res.json();
      if (data.success) setStats(data.data);
    } catch (err) { console.error('Stats fetch error:', err); }
  }, [token, selectedUsers]);

  const handleSync = async () => {
    setSyncing(true); setSyncResult(null);
    try {
      const res = await fetch(`${API_BASE}/coupons/sync?all=true`, { method: 'POST', headers: { Authorization: `Bearer ${token}` } });
      const data = await res.json();
      if (data.success && data.multi && Array.isArray(data.results)) {
        // Çoklu hesap sonucu
        const summary = data.results.map(r => {
          if (!r.success) return `${displayNameMap[r.nesineUser] || r.nesineUser || '-'}: HATA (${r.error})`;
          const parts = [`${displayNameMap[r.nesineUser] || r.nesineUser}: ${r.totalSynced} kupon`];
          if (r.pastMonthsFetched > 0) parts.push(`${r.pastMonthsFetched} eski ay`);
          if (r.detailsFetched > 0) parts.push(`${r.detailsFetched} detay`);
          if (r.royalMarked > 0) parts.push(`👑 ${r.royalMarked} royal`);
          if (r.rateLimitHit) parts.push('⚠️ Rate limit');
          return parts.join(', ');
        }).join(' | ');
        setSyncResult(summary);
        fetchCoupons(1); fetchStats(getFilterObj());
      } else if (data.success) {
        // Tek hesap sonucu (eski davranış)
        const parts = [`${data.totalSynced} kupon senkronize edildi`];
        if (data.pastMonthsFetched > 0) parts.push(`${data.pastMonthsFetched} eski ay çekildi`);
        if (data.detailsFetched > 0) parts.push(`${data.detailsFetched} detay alındı`);
        if (data.royalMarked > 0) parts.push(`👑 ${data.royalMarked} royal kupon işaretlendi`);
        if (data.rateLimitHit) parts.push('⚠️ Rate limit');
        setSyncResult(parts.join(', '));
        fetchCoupons(1); fetchStats(getFilterObj());
      } else { setSyncResult(data.error || 'Hata'); }
    } catch (err) { setSyncResult('Hata: ' + err.message); }
    setSyncing(false);
  };

  const handleBarcodeCheck = async () => {
    setBarcodeChecking(true); setBarcodeCheckResult(null);
    try {
      const res = await fetch(`${API_BASE}/coupons/barcode-check`, { method: 'POST', headers: { Authorization: `Bearer ${token}` } });
      const data = await res.json();
      if (data.success) {
        setBarcodeCheckResult(`${data.totalBarcodes} barkod kontrol edildi, ${data.royalMarked} kupon royal olarak işaretlendi`);
        if (data.royalMarked > 0) { fetchCoupons(1); fetchStats(getFilterObj()); }
      } else { setBarcodeCheckResult(data.error || 'Hata'); }
    } catch (err) { setBarcodeCheckResult('Hata: ' + err.message); }
    setBarcodeChecking(false);
  };

  useEffect(() => { fetchUsers(); }, [fetchUsers]);
  useEffect(() => {
    if (showBekleyen) fetchBekleyen(); else setBekleyen([]);
    fetchCoupons(1); fetchStats(getFilterObj());
  }, [showBekleyen, showKazanan, showKaybeden, showRoyal, selectedUsers, filterVersion]); // eslint-disable-line

  const getFilterObj = () => ({
    startDate: filterStartDate, endDate: filterEndDate, barcode: filterBarcode.trim(),
    minOdd: filterMinOdd, maxOdd: filterMaxOdd, minAmount: filterMinAmount, maxAmount: filterMaxAmount,
    minGain: filterMinGain, maxGain: filterMaxGain,
  });
  const handleFilter = () => { fetchCoupons(1); fetchStats(getFilterObj()); };
  const handleClear = () => {
    const now = new Date();
    const yy = now.getFullYear(), mm = String(now.getMonth() + 1).padStart(2, '0'), dd = String(now.getDate()).padStart(2, '0');
    setFilterStartDate(`${yy}-${mm}-01`); setFilterEndDate(`${yy}-${mm}-${dd}`); setFilterBarcode('');
    setFilterMinOdd(''); setFilterMaxOdd(''); setFilterMinAmount(''); setFilterMaxAmount('');
    setFilterPlayer(''); setFilterTeam(''); setFilterMinGain(''); setFilterMaxGain('');
    setShowBekleyen(true); setShowKazanan(true); setShowKaybeden(true); setShowRoyal(false);
    setFilterVersion(v => v + 1);
  };
  const handlePageChange = (page) => { fetchCoupons(page); };

  const formatDate = (epoch) => {
    if (!epoch) return '-';
    const d = new Date(epoch);
    return d.toLocaleDateString('tr-TR', { timeZone: 'Europe/Istanbul' }) + ' ' + d.toLocaleTimeString('tr-TR', { timeZone: 'Europe/Istanbul', hour: '2-digit', minute: '2-digit' });
  };
  const formatMoney = (val) => {
    const num = typeof val === 'string' ? parseFloat(val) : val;
    if (isNaN(num)) return '0,00';
    return num.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };
  const parseTL = (s) => {
    if (!s) return 0;
    return parseFloat(s.replace(/[^\d,.-]/g, '').replace(/\./g, '').replace(',', '.')) || 0;
  };

  const applyClientFilters = (list) => {
    return list.filter(c => {
      if (filterMinOdd) { if ((parseFloat(c.totalOdd) || 0) < parseFloat(filterMinOdd)) return false; }
      if (filterMaxOdd) { if ((parseFloat(c.totalOdd) || 0) > parseFloat(filterMaxOdd)) return false; }
      if (filterMinAmount) { if (parseTL(c.amount) < parseFloat(filterMinAmount)) return false; }
      if (filterMaxAmount) { if (parseTL(c.amount) > parseFloat(filterMaxAmount)) return false; }
      if (filterMinGain && c.couponResultType === 2) { if (parseTL(c.totalGain) < parseFloat(filterMinGain)) return false; }
      if (filterMaxGain && c.couponResultType === 2) { if (parseTL(c.totalGain) > parseFloat(filterMaxGain)) return false; }
      if (filterPlayer.trim()) {
        const q = filterPlayer.trim().toLowerCase();
        const hasPlayer = (c.events || []).some(ev => {
          const p = parseMatchName(ev.name);
          return (p.home.player && p.home.player.toLowerCase().includes(q)) || (p.away.player && p.away.player.toLowerCase().includes(q));
        });
        if (!hasPlayer) return false;
      }
      if (filterTeam.trim()) {
        const q = filterTeam.trim().toLowerCase();
        const hasTeam = (c.events || []).some(ev => ev.name && ev.name.toLowerCase().includes(q));
        if (!hasTeam) return false;
      }
      return true;
    });
  };

  const hasDbFilter = showKazanan || showKaybeden || showRoyal;
  const displayBekleyen = showBekleyen ? bekleyen : [];
  const displayDb = applyClientFilters(coupons);
  const allCards = [...displayBekleyen, ...displayDb];
  const isLoading = (showBekleyen && loadingBekleyen) || (hasDbFilter && loading);

  const renderCard = (c) => {
    const events = c.events || [];
    const mcc = c.multipleCouponCount || 1;
    const tutar = parseTL(c.amount);
    const kazanc = parseTL(c.totalGain);
    const kar = c.couponResultType === 2 ? kazanc - tutar : -tutar;
    const playTime = c.playedDateEpoch ? formatDate(c.playedDateEpoch) : `${c.playedDate} ${c.playedTime}`;
    const isWon = c.couponResultType === 2;
    const isLost = c.couponResultType === 3;
    const isPending = c.couponResultType === 6;
    const isRoyal = !!c.isRoyal;
    const cardClass = isRoyal ? 'cp-card cp-card-royal' : isWon ? 'cp-card cp-card-won' : isLost ? 'cp-card cp-card-lost' : isPending ? 'cp-card cp-card-pending' : 'cp-card';

    return (
      <div key={c.couponID || c._id || c.barcode} className={cardClass}>
        {/* ─── HEADER BAR ─── */}
        <div className="cp-c-header">
          <div className="cp-c-left">
            {users.length > 1 && c.nesineUser && <span className="cp-c-account">{displayNameMap[c.nesineUser] || c.nesineUser}</span>}
            <span className={`cp-c-badge ${isWon ? 'cp-c-badge-won' : isLost ? 'cp-c-badge-lost' : 'cp-c-badge-pending'}`}>
              {isWon ? '✅ KAZANDI' : isLost ? '❌ KAYBETTİ' : '⏳ BEKLİYOR'}
            </span>
            <span className="cp-c-time">{playTime}</span>
            <span className="cp-c-barcode">{c.barcode}</span>
          </div>
          <div className="cp-c-right">
            {isRoyal && <span className="cp-c-profit cp-c-profit-royal">👑 +{formatMoney(kar)} TL</span>}
            {!isRoyal && isWon && <span className="cp-c-profit cp-c-profit-won">+{formatMoney(kar)} TL</span>}
            {isLost && <span className="cp-c-profit cp-c-profit-lost">-{formatMoney(tutar)} TL</span>}
            {isPending && <span className="cp-c-profit cp-c-profit-pending">Bekliyor</span>}
          </div>
        </div>

        {/* ─── SUMMARY STRIP ─── */}
        <div className="cp-c-summary">
          <div className="cp-c-sum-item">
            <span className="cp-c-sum-label">Maç</span>
            <span className="cp-c-sum-val">{c.eventCount}</span>
          </div>
          <div className="cp-c-sum-item">
            <span className="cp-c-sum-label">Oran</span>
            <span className="cp-c-sum-val cp-c-sum-odd">{c.totalOdd}</span>
          </div>
          <div className="cp-c-sum-item">
            <span className="cp-c-sum-label">Tutar</span>
            <span className="cp-c-sum-val">{mcc > 1 ? `${mcc} × ${formatMoney(tutar / mcc)} TL` : c.amount}</span>
          </div>
          {isWon && (
            <div className="cp-c-sum-item">
              <span className="cp-c-sum-label">Kazanç</span>
              <span className="cp-c-sum-val cp-c-sum-gain">{c.totalGain}</span>
            </div>
          )}
          {c.system && c.system !== '-' && (
            <div className="cp-c-sum-item">
              <span className="cp-c-sum-label">Sistem</span>
              <span className="cp-c-sum-val">{c.system}</span>
            </div>
          )}
        </div>

        {/* ─── EVENTS ─── */}
        {events.length > 0 && (
          <div className="cp-c-events">
            {events.map((ev, i) => {
              const allWin = ev.outcomes?.every(o => o.status === 'Win');
              const anyLoss = ev.outcomes?.some(o => o.status === 'Loss');
              const rowClass = allWin ? 'cp-e cp-e-won' : anyLoss ? 'cp-e cp-e-lost' : 'cp-e cp-e-pending';
              const parsed = parseMatchName(ev.name);
              const hasPlayers = parsed.home.player || parsed.away.player;
              return (
                <div key={i} className={rowClass}>
                  {/* Match name area */}
                  <div className="cp-e-left">
                    {hasPlayers ? (
                      <>
                        <div className="cp-e-players">
                          <span className="cp-e-player">{parsed.home.player}</span>
                          <span className="cp-e-vs">vs</span>
                          <span className="cp-e-player">{parsed.away.player}</span>
                        </div>
                        <div className="cp-e-teams">{parsed.home.team} - {parsed.away.team}</div>
                      </>
                    ) : (
                      <div className="cp-e-teams-big">{parsed.home.team} - {parsed.away.team}</div>
                    )}
                    <div className="cp-e-meta">
                      <span>{ev.startDate} {ev.startTime}</span>
                      <span className="cp-e-market">{ev.marketName}</span>
                    </div>
                  </div>

                  {/* Scores */}
                  <div className="cp-e-center">
                    {ev.resultMatch && <span className="cp-e-score">MS {ev.resultMatch}</span>}
                    {ev.resultHalf && <span className="cp-e-score cp-e-score-dim">İY {ev.resultHalf}</span>}
                  </div>

                  {/* Outcome */}
                  <div className="cp-e-right">
                    {ev.outcomes?.map((o, j) => (
                      <div key={j} className={`cp-e-out ${o.status === 'Win' ? 'cp-e-out-won' : o.status === 'Loss' ? 'cp-e-out-lost' : 'cp-e-out-pending'}`}>
                        <span className="cp-e-out-icon">{o.status === 'Win' ? '✅' : o.status === 'Loss' ? '❌' : '⏳'}</span>
                        <span className="cp-e-out-name">{o.name}</span>
                        {o.handicap && <span className="cp-e-out-hc">({o.handicap})</span>}
                        <span className="cp-e-out-odd">{o.odd}</span>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        )}
        {events.length === 0 && (
          <div className="cp-c-noev">{c.detailFetched ? 'Detay bilgisi yok' : 'Detay henüz çekilmedi'}</div>
        )}
      </div>
    );
  };

  return (
    <div className="my-coupons">
      {/* Header */}
      <div className="cp-header">
        <div className="cp-header-left">
          <h2>🎫 Kuponlarım</h2>
        </div>
        <div className="cp-header-right">
          <button className="cp-sync-btn" onClick={handleBarcodeCheck} disabled={barcodeChecking} style={{ marginRight: 8 }}>
            {barcodeChecking ? '⏳ Kontrol ediliyor...' : '👑 Barkod Kontrol'}
          </button>
          <button className="cp-sync-btn" onClick={handleSync} disabled={syncing}>
            {syncing ? '⏳ Senkronize ediliyor...' : '🔄 Senkronize Et'}
          </button>
        </div>
      </div>

      {syncResult && <div className="cp-sync-result">{syncResult}</div>}
      {barcodeCheckResult && <div className="cp-sync-result">{barcodeCheckResult}</div>}

      {/* User toggle buttons */}
      {users.length > 1 && (
        <div className="ca-user-btns">
          <button className={`ca-user-btn ${selectedUsers.length === 0 ? 'active' : ''}`} onClick={() => setSelectedUsers([])}>
            Tümü
          </button>
          {users.map(u => (
            <button key={u} className={`ca-user-btn ${selectedUsers.includes(u) ? 'active' : ''}`} onClick={() => {
              setSelectedUsers(prev => prev.includes(u) ? prev.filter(x => x !== u) : [...prev, u]);
            }}>
              {displayNameMap[u] || u}{u === currentUser ? ' (aktif)' : ''}
            </button>
          ))}
        </div>
      )}

      {/* Stats */}
      {stats && (
        <div className="cp-stats">
          <div className="cp-stat cp-stat-won">
            <div className="cp-stat-label">KAZANÇ</div>
            <div className="cp-stat-value">{formatMoney(stats.totalWonGain)} TL</div>
            <div className="cp-stat-sub">{stats.wonCount} kupon</div>
          </div>
          <div className="cp-stat cp-stat-lost">
            <div className="cp-stat-label">TUTAR</div>
            <div className="cp-stat-value">{formatMoney(stats.totalAllAmount)} TL</div>
            <div className="cp-stat-sub">{stats.wonCount + stats.lostCount} kupon</div>
          </div>
          <div className={`cp-stat ${parseFloat(stats.netProfit) >= 0 ? 'cp-stat-profit' : 'cp-stat-loss'}`}>
            <div className="cp-stat-label">KAR / ZARAR</div>
            <div className="cp-stat-value">{formatMoney(stats.netProfit)} TL</div>
          </div>
        </div>
      )}

      {/* Filters */}
      <div className="cp-filters">
        <div className="cp-filters-row">
          <div className="cp-fg">
            <label>Başlangıç</label>
            <input type="date" value={filterStartDate} onChange={e => setFilterStartDate(e.target.value)} />
          </div>
          <div className="cp-fg">
            <label>Bitiş</label>
            <input type="date" value={filterEndDate} onChange={e => setFilterEndDate(e.target.value)} />
          </div>
          <div className="cp-fg">
            <label>Barkod</label>
            <input type="text" placeholder="Barkod..." value={filterBarcode} onChange={e => setFilterBarcode(e.target.value)} />
          </div>
          <div className="cp-fg">
            <label>Oyuncu</label>
            <input type="text" placeholder="Oyuncu adı..." value={filterPlayer} onChange={e => setFilterPlayer(e.target.value)} />
          </div>
          <div className="cp-fg">
            <label>Takım</label>
            <input type="text" placeholder="Takım adı..." value={filterTeam} onChange={e => setFilterTeam(e.target.value)} />
          </div>
        </div>
        <div className="cp-filters-row">
          <div className="cp-fg cp-fg-sm">
            <label>Min Oran</label>
            <input type="number" step="0.01" placeholder="Min" value={filterMinOdd} onChange={e => setFilterMinOdd(e.target.value)} />
          </div>
          <div className="cp-fg cp-fg-sm">
            <label>Max Oran</label>
            <input type="number" step="0.01" placeholder="Max" value={filterMaxOdd} onChange={e => setFilterMaxOdd(e.target.value)} />
          </div>
          <div className="cp-fg cp-fg-sm">
            <label>Min Tutar</label>
            <input type="number" step="0.01" placeholder="Min TL" value={filterMinAmount} onChange={e => setFilterMinAmount(e.target.value)} />
          </div>
          <div className="cp-fg cp-fg-sm">
            <label>Max Tutar</label>
            <input type="number" step="0.01" placeholder="Max TL" value={filterMaxAmount} onChange={e => setFilterMaxAmount(e.target.value)} />
          </div>
          <div className="cp-fg cp-fg-sm">
            <label>Min Kazanç</label>
            <input type="number" step="0.01" placeholder="Min TL" value={filterMinGain} onChange={e => setFilterMinGain(e.target.value)} />
          </div>
          <div className="cp-fg cp-fg-sm">
            <label>Max Kazanç</label>
            <input type="number" step="0.01" placeholder="Max TL" value={filterMaxGain} onChange={e => setFilterMaxGain(e.target.value)} />
          </div>
          <div className="cp-filter-actions">
            <button className="cp-btn-filter" onClick={handleFilter}>🔍 Filtrele</button>
            <button className="cp-btn-clear" onClick={handleClear}>🗑️ Temizle</button>
          </div>
        </div>
      </div>

      {/* Type Toggles */}
      <div className="cp-toggles">
        <button className={`cp-toggle ${showBekleyen ? 'active cp-tgl-bek' : ''}`} onClick={() => { setShowBekleyen(!showBekleyen); setShowRoyal(false); }}>
          ⏳ Bekleyen {showBekleyen && bekleyen.length > 0 ? `(${bekleyen.length})` : ''}
        </button>
        <button className={`cp-toggle ${showKazanan ? 'active cp-tgl-kaz' : ''}`} onClick={() => { setShowKazanan(!showKazanan); setShowRoyal(false); }}>
          ✅ Kazanan
        </button>
        <button className={`cp-toggle ${showKaybeden ? 'active cp-tgl-kay' : ''}`} onClick={() => { setShowKaybeden(!showKaybeden); setShowRoyal(false); }}>
          ❌ Kaybeden
        </button>
        <button className={`cp-toggle ${showRoyal ? 'active cp-tgl-royal' : ''}`} onClick={() => { setShowRoyal(!showRoyal); if (!showRoyal) { setShowBekleyen(false); setShowKazanan(false); setShowKaybeden(false); } }}>
          👑 Royal
        </button>
        {showBekleyen && (
          <button className="cp-btn-refresh" onClick={fetchBekleyen} disabled={loadingBekleyen}>
            {loadingBekleyen ? '⏳...' : '🔄 Yenile'}
          </button>
        )}
        {onNavigate && (
          <button className="cp-toggle active" style={{ background: 'linear-gradient(135deg, #4a3a60, #5a4a80)', borderColor: '#7a6ab0', color: '#ddf', marginLeft: 'auto' }} onClick={() => onNavigate('couponAnalysis')}>
            📊 Analiz
          </button>
        )}
      </div>

      {/* Top Pagination */}
      {hasDbFilter && pagination.totalPages > 1 && (
        <Pagination page={pagination.page} totalPages={pagination.totalPages} total={pagination.total} onPageChange={handlePageChange} />
      )}

      {/* Cards */}
      <div className="cp-cards">
        {isLoading ? (
          <div className="cp-loading">Yükleniyor...</div>
        ) : allCards.length === 0 ? (
          <div className="cp-empty">{showBekleyen && !isLoggedIn && !hasDbFilter ? 'Nesine oturumu kapalı' : 'Kupon bulunamadı'}</div>
        ) : (
          allCards.map(c => renderCard(c))
        )}
      </div>

      {/* Bottom Pagination */}
      {hasDbFilter && pagination.totalPages > 1 && (
        <Pagination page={pagination.page} totalPages={pagination.totalPages} total={pagination.total} onPageChange={handlePageChange} />
      )}
    </div>
  );
}

export default MyCoupons;
